// extracted by mini-css-extract-plugin
module.exports = {"root":"SuccessMessage_root__2_50g","text":"SuccessMessage_text__-XDLL","active":"SuccessMessage_active__2RF5b"};